import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import Layout from '../Layout';
import PrivacyText from '../Helper/PrivacyText';
import { FREE_PRODUCTS } from './constants';

const EmailConfirm = withTranslation()(({ routing, auth, t }) => {
  const { firstName, lastName, email } = auth;
  const isFreeProduct = FREE_PRODUCTS.includes(routing.query?.productCode);
  return (
    <Layout className="trial confirm" cover={{ src: '/images/cover-main.png' }}>
      <div className="wrapper-shrink">
        <h1 className="title">{t('Confirm your email.')}</h1>
        {isFreeProduct ? (
          <p className="subtitle">{t('You will use it to access your product.')}</p>
        ) : (
          <p className="subtitle">{t('You will use it to access your trial.')}</p>
        )}
        <div className="confirm-content">
          <div className="user-data">
            <p>
              {firstName} {lastName}
            </p>
            <p>
              <strong>{email}</strong>
            </p>
          </div>

          <PrivacyText className="privacy-text" i18nKey="privacy-text-trial" />
        </div>
        <div className="login-button-wrapper">
          <button
            type="submit"
            className="button btn-active"
            onClick={() => {
              const returnTo = routing.query?.return_to;
              const redirectAddress = new URL(returnTo || window.TRIAL_ADDR);
              redirectAddress.searchParams.append('isNewAccount', false);
              window.location = redirectAddress;
            }}
          >
            {isFreeProduct ? t('Get started') : t('Start your trial')}
          </button>
        </div>
      </div>
    </Layout>
  );
});

export default connect((state) => ({
  routing: state.routing,
  auth: state.app,
}))(withTranslation()(EmailConfirm));
